export default [
  {
    path: '/wallet',
    component: () => import('@/views/pages/wallet/index.vue'),
    redirect: '/wallet/money',
    children: [
      {
        path: 'money',
        component: () => import('@/views/pages/wallet/money.vue')
      },
      {
        path: 'coupon',
        component: () => import('@/views/pages/wallet/coupon.vue')
      },
      {
        path: 'invoice',
        component: () => import('@/views/pages/wallet/invoice.vue')
      }
    ]
  }
]
